import React from 'react';
import { connect } from 'react-redux';
import { forEach, get } from 'lodash';
import { hasFeatureFlags } from 'utils/features';
import * as actions from 'actions/shared/index/filter';
import * as dataActions from 'actions/shared/index/data';
import IndexWindowLocation from '../../shared/index/window_location';
import LeftSidebar from './LeftSidebar';
import PeopleHeader from '../header';
import PeopleFilters from '../filters';
import PeopleActionBar from '../action_bar';
import PeopleDataView from '../data_view';
import PeopleTableBody from '../table/body';
import IndexTable from '../../shared/index/table';
import RuleBuilderModal from './RuleBuilder/RuleBuilderModal';
import ArchiveButton from '../../shared/index/archive_button';
import { filterUpdateAll } from '../../../actions/shared/index/filter';
import { peopleTableHeaders } from '../../../constants/tableHeaders';
import Organization from '../organization';

class PeopleAdvancedIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: props.editing,
      activeGroup: props.editing ? props.activeGroup : null,
      groupsListVisible: false,
    };
    this.createNewRuleBasedGroup = this.createNewRuleBasedGroup.bind(this);
    this.editRuleBasedGroup = this.editRuleBasedGroup.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggleGroupsList = this.toggleGroupsList.bind(this);
  }

  componentDidMount() {
    this.props.updateAll();
  }

  createNewRuleBasedGroup() {
    this.setState({ activeGroup: null, modalVisible: true });
  }

  editRuleBasedGroup(activeGroup) {
    this.setState({ activeGroup, modalVisible: true });
    this.props.updateEditing('true');
  }

  closeModal() {
    this.setState({ activeGroup: null, modalVisible: false });
    this.props.updateEditing('false');
  }

  sortGroups() {
    return this.props.groups.reduce((sortedGroups, group) => {
      if (!sortedGroups[group.type]) {
        sortedGroups[group.type] = [];
      }

      sortedGroups[group.type].push(group);

      return sortedGroups;
    }, {});
  }

  toggleGroupsList() {
    this.setState(state => ({ groupsListVisible: !state.groupsListVisible }));
  }

  hasManagedGroups = () => {
    return (
      this.props.permissions.manageAllGroups || this.props.groups.length !== 0
    );
  };

  render() {
    const { loaded, groups, updateActiveGroup, updateMyOrganization } =
      this.props;

    const sortedGroups = this.sortGroups();
    const hasUnificationFeatureFlag = hasFeatureFlags([
      'readiness-enable-unification',
    ]);
    const canEditPeople =
      this.props.permissions.editGroups && !hasUnificationFeatureFlag;

    if (loaded) {
      return (
        <div className="Index PageWithSidebar People">
          <IndexWindowLocation omitParam="per_page" />
          <div className="People-side trk_container_readiness_people-groups-sidebar">
            <LeftSidebar
              groups={groups}
              sortedGroups={sortedGroups}
              updateActiveGroup={updateActiveGroup}
              createNewRuleBasedGroup={this.createNewRuleBasedGroup}
              groupsListVisible={this.state.groupsListVisible}
              toggleGroupsList={this.toggleGroupsList}
              updateMyOrganization={updateMyOrganization}
            />
          </div>
          <div className="People-table container clearfix">
            {this.props.myOrganization && (
              <Organization
                updateActiveGroup={updateActiveGroup}
                updateMyOrganization={updateMyOrganization}
                hasUnificationFeatureFlag={hasUnificationFeatureFlag}
              />
            )}
            {!this.props.myOrganization && (
              <>
                <PeopleHeader
                  editRuleBasedGroup={this.editRuleBasedGroup}
                  createNewRuleBasedGroup={this.createNewRuleBasedGroup}
                  toggleGroupsList={this.toggleGroupsList}
                  groupsListVisible={this.state.groupsListVisible}
                  hasManagedGroups={this.hasManagedGroups()}
                  hasUnificationFeatureFlag={hasUnificationFeatureFlag}
                />
                <PeopleFilters />
                <PeopleActionBar />
                <PeopleDataView
                  editRuleBasedGroup={this.editRuleBasedGroup}
                  hasManagedGroups={this.hasManagedGroups()}
                >
                  <IndexTable
                    tableHeaders={peopleTableHeaders}
                    selectable={canEditPeople}
                  >
                    <PeopleTableBody selectable={canEditPeople} />
                  </IndexTable>
                </PeopleDataView>
                {canEditPeople && <ArchiveButton type="user" />}
              </>
            )}
          </div>

          {this.state.modalVisible && (
            <RuleBuilderModal
              customGroups={get(sortedGroups, 'Group', [])}
              closeModal={this.closeModal}
              activeGroup={this.state.activeGroup}
              updateActiveGroup={this.props.updateActiveGroup}
              setGroupInMeta={this.props.setGroupInMeta}
            />
          )}
        </div>
      );
    }
    return <div />;
  }
}

function groupsToArray(groupsObject) {
  const groupsArray = [];
  forEach(groupsObject, (value, key) => {
    value.id = key;
    groupsArray.push(value);
  });
  return groupsArray;
}

const mapStateToProps = state => ({
  loaded: state.data.content,
  groups: groupsToArray(state.data.meta.groups),
  activeGroup: state.filter.activeGroup,
  editing: state.filter.editing && !!state.filter.activeGroup,
  myOrganization: state.filter.myOrganization,
  permissions: state.data.meta.permissions,
});

const mapDispatchToProps = dispatch => ({
  updateAll() {
    dispatch(filterUpdateAll());
  },
  updateActiveGroup(group) {
    dispatch(actions.filterUpdateActiveGroup(group));
  },
  updateEditing(editing) {
    dispatch(actions.filterUpdateEditing(editing));
  },
  setGroupInMeta(data) {
    dispatch(dataActions.setGroupInMeta(data));
  },
  updateMyOrganization(showMyOrganization) {
    dispatch(actions.filterUpdateMyOrganization(showMyOrganization));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PeopleAdvancedIndex);
